import axios from 'axios';

// Create an instance of axios with the base URL of our backend
const api = axios.create({
    baseURL: 'https://mataxexpress.up.railway.app/api', // Your Flask backend URL
});

// This is a powerful feature: an "interceptor"
// It runs before every request is sent
api.interceptors.request.use((config) => {
    // Get the token from browser's local storage
    const token = localStorage.getItem('accessToken');
    if (token) {
        // If token exists, add it to the 'Authorization' header
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => {
    return Promise.reject(error);

});

export default api;